import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Alert, Button, FormCheck, FormControl, FormGroup, FormLabel } from 'react-bootstrap'
import {
  cancelIdentityInfoModalDialog,
  closeIdentityInfoModalDialog,
  saveChangesIdentityInfoModalDialog,
  updateIdentity,
  validateIdentityInfoModalDialog,
} from '../../actions/identity_info_modal_dialog'
import { fetchAppContextForTx } from '../../actions/app_context'
import validator from 'validator'
import moment from 'moment'
import TextFieldFormGroup from '../common/form/text_field_form_group'
import { fetchUserTxById } from '../../actions'
import { countries } from 'country-data'
import SelectFieldFormGroup from '../common/form/select_field_form_group'
import { toCamelCase } from '../../utils/helpers'

class IdentityInfoForm extends PureComponent {
  genders = ['male', 'female', 'unknown', 'other'].sort()
  signerTypes = ['signatory', 'beneficial_owner'].sort()
  investorTypes = ['private_party', 'corporate_entity'].sort()

  validationStateError = 'error'
  validationStateSuccess = 'success'
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  birthDateInputStyle = { width: '33.33%', display: 'inline-block' }

  constructor(props) {
    super(props)
    this.state = {
      firstName: null,
      firstNameValidated: null,
      firstNameValidationState: null,
      lastName: null,
      lastNameValidated: null,
      lastNameValidationState: null,
      middleName: null,
      middleNameValidated: null,
      middleNameValidationState: null,
      alias: null,
      aliasValidated: null,
      aliasValidationState: null,
      gender: null,
      birthDate: null,
      birthDateValidated: null,
      birthDateValidationState: null,
      investorType: null,
      signerType: null,
      driversLicense: null,
      driversLicenseValidated: null,
      driversLicenseValidationState: null,
      passportNumber: null,
      passportNumberValidated: null,
      passportNumberValidationState: null,
      isAccreditedInvestor: null,
      notes: null,
      passDlStaticControl: null,
      countryCode: null,
      countryCodeValidationState: null,
      nameValidated: null,
      nameValidationState: null,
      changed: false,

      birthMonth: '',
      birthDay: '',
      birthYear: '',
    }
  }

  componentDidMount() {
    const { identityData } = this.props
    const bod = identityData.birth_date ? moment(identityData.birth_date) : null
    this.setState({
      birthDate: bod,
      birthMonth: bod ? bod.format('MMMM') : 'January', // default value in select
      birthDay: bod ? bod.format('DD') : '',
      birthYear: bod ? bod.format('YYYY') : '',
      passportNumber: identityData.passport_number,
      driversLicense: identityData.drivers_license,
      firstName: identityData ? identityData.first_name : '',
      lastName: identityData ? identityData.last_name : '',
    })

    this.displayPassDLNotice(identityData.drivers_license, identityData.passport_number)
  }

  displayPassDLNotice = (driversLicense, passportNumber) => {
    let cssKlass
    if (this.isBothDLAndPassportInvalid(driversLicense, passportNumber)) {
      cssKlass = 'text-danger font-bold'
    } else {
      cssKlass = 'text-default font-bold'
    }
    this.setState({
      passDlStaticControl: (
        <FormControl.Static>
          <span className={cssKlass}>Either Driver License/Government ID or Passport Number Must Be Provided</span>
        </FormControl.Static>
      ),
    })
  }

  isBothDLAndPassportInvalid = (driversLicense, passportNumber) => {
    const isDlNotValid =
      IdentityInfoForm.validate(driversLicense || '', true, ['isAlphaNumericWithParenthesesAndSpaceAndDash']) ===
      this.validationStateError
    const isPassNotValid =
      IdentityInfoForm.validate(passportNumber || '', true, ['isAlphaNumericWithSpaceAndDash']) ===
      this.validationStateError
    return isDlNotValid && isPassNotValid
  }

  collectBirthDateFromState = () => {
    let birthMonth = this.state.birthMonth
    let birthDay = this.state.birthDay
    let birthYear = this.state.birthYear
    return new Date(birthYear, this.months.indexOf(birthMonth), birthDay)
  }

  /**
   * Validation on click event handling
   * @param e
   */
  handleSaveChanges(e) {
    const { state } = this
    const { updateIdentity, identityData, saveChangesIdentityInfoModalDialog } = this.props

    if (!state.changed) {
      this.handleCloseModal()
      return
    }

    let newData = {}
    let newBirthDateStr = ''
    for (let prop in identityData) {
      if (identityData.hasOwnProperty(prop)) {
        const oldValue = identityData[prop]
        const newProp = toCamelCase(prop)
        if (this.state.hasOwnProperty(newProp)) {
          const newValue = this.state[newProp]
          // handle date
          if (prop === 'birth_date') {
            if (newValue !== null) {
              newBirthDateStr = moment(this.collectBirthDateFromState()).format('YYYY-MM-DD')
              if (newBirthDateStr !== oldValue) {
                newData = { ...newData, [prop]: newBirthDateStr }
              }
            } else {
              newData = { ...newData, [prop]: null }
            }
            continue
          }

          if (newValue !== null && newValue !== oldValue) {
            newData = { ...newData, [prop]: newValue }
          }
        }
      }
    }
    const outstandingValidationCount = Object.keys(this.state)
      .filter((element) => element.endsWith('Validated'))
      .filter((key) => this.state[key] === false).length

    if (
      outstandingValidationCount ||
      this.isBothDLAndPassportInvalid(this.state.driversLicense, this.state.passportNumber)
    ) {
      window.alert('Please check validation')
      return
    }
    if (!Object.keys(newData).length) {
      window.alert('Nothing to save - no changes detected')
      return
    }

    if (!newBirthDateStr) {
      if (window.confirm('Date of a birth is a required field in many jurisdictions. Would you like to enter it?')) {
        return
      }
    }

    if (this.state.birthDateValidationState === this.validationStateError) {
      window.alert('Please check Birth Date')
      return
    }

    if (!state.firstName) {
      if (window.confirm('First Name is a required field in many jurisdictions. Would you like to enter it?')) {
        return
      }
    }

    if (!state.lastName) {
      if (
        window.confirm(
          'Last Name is a required field in many jurisdictions. Would you like to enter it? \n' +
            'Click OK to enter a last name. Click Cancel to bypass and save record with no last name.'
        )
      ) {
        return
      }
    }

    updateIdentity(identityData.id, newData)
    saveChangesIdentityInfoModalDialog(newData)
  }

  static validate(value, required = false, validators = []) {
    if (required) {
      if (value.length < 1) {
        return 'error'
      }
    }

    if (value.length < 1) {
      return
    }

    for (let val in validators) {
      let result = true
      switch (validators[val]) {
        case 'isAlpha':
          result = validator.isAlpha(value)
          break
        case 'isAlphaNumericWithSpaceAndDash':
          result = validator.matches(value, /^[\w- ]+$/)
          break
        case 'isAlphaNumericWithParenthesesAndSpaceAndDash':
          result = validator.matches(value, /^[\w-() ]+$/)
          break
        case 'matchesDate':
          result = validator.matches(value, /^\d{4}-\d{2}-\d{2}$/)
          break
        case 'matchesName':
          result = validator.matches(value, /^[a-zA-Z. ]+$/)
          break
        default:
          throw Error('Invalid validator type')
      }
      if (value.length > 0 && !result) {
        return 'error'
      }
    }
    return 'success'
  }

  handleFieldChangeNoValidation(e, name) {
    this.setState({ [name]: e.target.value })
  }

  handleFieldChange(e, name, required = false, validators = []) {
    const { value } = e.target
    this.setState(
      () => ({
        changed: true,
        [name]: value,
      }),
      () => {
        if (name === 'birthDay' || name === 'birthYear' || name === 'birthMonth') {
          this.handleBirthDateChange()
        }
        if (name === 'firstName' || name === 'lastName') {
          this.handleNameChange()
        }
      }
    )

    const result = IdentityInfoForm.validate(value, required, validators)
    if (result === this.validationStateError) {
      this.setState({ [name + 'Validated']: false, [name + 'ValidationState']: result })
    }
    if (result === this.validationStateSuccess) {
      this.setState({ [name + 'Validated']: true, [name + 'ValidationState']: result })
    }
  }

  handleBirthDateChange() {
    const { birthMonth, birthDay, birthYear } = this.state
    let month = (this.months.indexOf(birthMonth) + 1).toString()
    if (month.length === 1) {
      month = `0${month}`
    }
    let day = birthDay.toString()
    if (day.length === 1) {
      day = `0${day}`
    }

    const birthYearIsValid = birthYear >= 1919 && birthYear <= 2009

    if (!moment(`${birthYear}/${month}/${day}`, 'YYYY/MM/DD', true).isValid() || !birthYearIsValid) {
      this.setState({ birthDateValidated: true, birthDateValidationState: this.validationStateError })
    } else {
      this.setState({
        birthDateValidated: true,
        birthDateValidationState: null,
        birthDate: moment(this.collectBirthDateFromState()).format('YYYY-MM-DD'),
      })
    }
  }

  handleNameChange = () => {
    const { state } = this
    const { firstName, lastName } = state
    if (firstName || lastName) {
      this.setState({
        nameValidated: true,
        nameValidationState: this.validationStateSuccess,
        firstNameValidated: true,
        lastNameValidated: true,
      })
    } else if (!firstName && !lastName) {
      this.setState({
        nameValidated: false,
        nameValidationState: this.validationStateError,
        firstNameValidated: false,
        lastNameValidated: false,
      })
    } else {
      this.setState({ nameValidated: false, nameValidationState: this.validationStateError })
    }
  }

  handleCheckboxClick(e, name) {
    const isCheckbox = e.target.type === 'checkbox'
    if (!isCheckbox) {
      throw Error(name + ' not a checkbox type')
    }
    this.setState({
      [name]: e.target.checked,
    })
  }

  handleCloseModal(e) {
    const { fetchUserTxById, closeIdentityInfoModalDialog, identityData, fetchAppContextForTx } = this.props
    fetchUserTxById(identityData.transaction).then(() => {
      fetchAppContextForTx(identityData.transaction)
    })
    closeIdentityInfoModalDialog()
  }

  handleDriverLicenseChange = (e) => {
    let isFieldRequired = !this.state.passportNumber
    this.handleFieldChange(e, 'driversLicense', isFieldRequired, ['isAlphaNumericWithParenthesesAndSpaceAndDash'])
    if (e.target.value.length && !this.state.passportNumberValidated) {
      this.setState({ passportNumberValidated: null, passportNumberValidationState: null })
    }
    if (e.target.value.length === 0 && this.state.passportNumber.length) {
      this.setState({ driversLicenseValidated: null, driversLicenseValidationState: null })
    }
    this.displayPassDLNotice(e.target.value, this.state.passportNumber)
  }

  handlePassportNumberChange = (e) => {
    let isFieldRequired = !this.state.driversLicense
    this.handleFieldChange(e, 'passportNumber', isFieldRequired, ['isAlphaNumericWithSpaceAndDash'])
    if (e.target.value.length && !this.state.driversLicenseValidated) {
      this.setState({ driversLicenseValidated: null, driversLicenseValidationState: null })
    }
    if (e.target.value.length === 0 && this.state.driversLicense.length) {
      this.setState({ passportNumberValidated: null, passportNumberValidationState: null })
    }
    this.displayPassDLNotice(this.state.driversLicense, e.target.value)
  }

  get firstNameValidationState() {
    const { firstName, lastName, changed } = this.state
    if (!changed) {
      return null
    }
    if (firstName && lastName) {
      return this.validationStateSuccess
    } else if (!firstName && !lastName) {
      return this.validationStateError
    } else if (firstName && !lastName) {
      return this.validationStateSuccess
    } else if (!firstName && lastName) {
      return null
    }
    return null
  }

  get lastNameValidationState() {
    const { firstName, lastName, changed } = this.state
    if (!changed) {
      return null
    }
    if (firstName && lastName) {
      return this.validationStateSuccess
    } else if (!firstName && !lastName) {
      return this.validationStateError
    } else if (!firstName && lastName) {
      return this.validationStateSuccess
    } else if (firstName && !lastName) {
      return null
    }
    return null
  }

  render() {
    const { props, state } = this
    const { identityData, cancelIdentityInfoModalDialog, isChangesSaved, isValidated, currentPhase } = props

    let firstName = state.firstName

    if (state.firstName === null) {
      firstName = identityData.first_name || ''
    }

    let middleName = state.middleName
    if (state.middleName === null) {
      middleName = identityData.middle_name || ''
    }

    let lastName = state.lastName
    if (state.lastName === null) {
      lastName = identityData.last_name || ''
    }

    let alias = state.alias
    if (state.alias === null) {
      alias = identityData.alias || ''
    }

    let gender = state.gender
    if (state.gender === null) {
      gender = identityData.gender || ''
    }

    const selectedGender = gender || 'Select'

    let investorType = state.investorType
    if (state.investorType === null) {
      investorType = identityData.investor_type || ''
    }

    const selectedInvestorType = investorType || 'Select'

    let birthMonth = state.birthMonth
    const selectedBirthMonth = birthMonth || 'Select'

    let birthDay = state.birthDay
    let birthYear = state.birthYear

    let signerType = state.signerType
    if (state.signerType === null) {
      signerType = identityData.signer_type || ''
    }

    const selectedSignerType = signerType || 'Select'

    let driversLicense = state.driversLicense
    if (state.driversLicense === null) {
      driversLicense = identityData.drivers_license || ''
    }

    let passportNumber = state.passportNumber
    if (state.passportNumber === null) {
      passportNumber = identityData.passport_number || ''
    }

    let isAccreditedInvestor = state.isAccreditedInvestor
    if (state.isAccreditedInvestor === null) {
      isAccreditedInvestor = identityData.is_accredited_investor || false
    }

    let notes = state.notes
    if (state.notes === null) {
      notes = identityData.notes || ''
    }

    let countryCode = state.countryCode
    if (state.countryCode === null) {
      countryCode = identityData.country_code || ''
    }
    const selectedCountryCode = countryCode || 'Select'

    return (
      <form>
        <TextFieldFormGroup
          help='Required'
          value={firstName}
          controlId='firstName'
          controlLabel='First Name'
          validationState={this.firstNameValidationState}
          handleFieldChange={(e) => this.handleFieldChange(e, 'firstName', true)}
        />

        <TextFieldFormGroup
          value={middleName}
          controlId='middleName'
          controlLabel='Middle Name'
          validationState={state.middleNameValidationState}
          handleFieldChange={(e) => this.handleFieldChange(e, 'middleName', false)}
        />

        <TextFieldFormGroup
          help='Required'
          value={lastName}
          controlId='lastName'
          controlLabel='Last Name'
          validationState={this.lastNameValidationState}
          handleFieldChange={(e) => this.handleFieldChange(e, 'lastName', true)}
        />

        <TextFieldFormGroup
          value={alias}
          controlId='alias'
          controlLabel='Alias'
          validationState={state.aliasValidationState}
          handleFieldChange={(e) => this.handleFieldChange(e, 'alias', false, ['isAlpha'])}
        />

        <FormGroup controlId='gender'>
          <FormLabel>Gender</FormLabel>
          <FormControl
            value={selectedGender}
            as='select'
            placeholder='select'
            onChange={(e) => this.handleFieldChangeNoValidation(e, 'gender')}
          >
            <option key={'select'} defaultValue={'Select'}>
              Select
            </option>
            {this.genders.map((gender) => (
              <option key={gender} value={gender}>
                {gender.toUpperCase()}
              </option>
            ))}
          </FormControl>
        </FormGroup>

        <FormGroup controlId='birthDate' validationState={state.birthDateValidationState}>
          <FormLabel>Birth Date</FormLabel>
          <br />
          <FormControl
            style={{ ...this.birthDateInputStyle, position: 'relative', top: '-1px' }}
            value={selectedBirthMonth}
            as='select'
            placeholder='select'
            onChange={(e) => this.handleFieldChange(e, 'birthMonth')}
          >
            {this.months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </FormControl>
          <FormControl
            style={this.birthDateInputStyle}
            value={birthDay}
            placeholder='Day'
            type='number'
            min='1'
            max='31'
            onChange={(e) => {
              this.handleFieldChange(e, 'birthDay', true)
            }}
          />
          <FormControl
            style={this.birthDateInputStyle}
            value={birthYear}
            placeholder='Year'
            type='number'
            min='1900'
            max='2019'
            onChange={(e) => this.handleFieldChange(e, 'birthYear', true)}
          />
        </FormGroup>

        <SelectFieldFormGroup
          help='Required'
          value={selectedCountryCode}
          controlId='countryCode'
          controlLabel='Country Code'
          data={countries.all}
          propName={'alpha2'}
          validationState={state.countryCodeValidationState}
          handleFieldChange={(e) => this.handleFieldChange(e, 'countryCode', true)}
        />

        <FormGroup controlId='investorType'>
          <FormLabel>Investor Type</FormLabel>
          <FormControl
            value={selectedInvestorType}
            as='select'
            placeholder='select'
            onChange={(e) => this.handleFieldChangeNoValidation(e, 'investorType')}
          >
            <option key={'select'} defaultValue={'Select'}>
              Select
            </option>
            {this.investorTypes.map((investorType) => (
              <option key={investorType} value={investorType}>
                {investorType.toUpperCase()}
              </option>
            ))}
          </FormControl>
        </FormGroup>

        <FormGroup controlId='signerType'>
          <FormLabel>Signer Type</FormLabel>
          <FormControl
            value={selectedSignerType}
            as='select'
            placeholder='select'
            onChange={(e) => this.handleFieldChangeNoValidation(e, 'signerType')}
          >
            <option key={'select'} defaultValue={'Select'}>
              Select
            </option>
            {this.signerTypes.map((signerType) => (
              <option key={signerType} value={signerType}>
                {signerType.toUpperCase()}
              </option>
            ))}
          </FormControl>
        </FormGroup>
        {state.passDlStaticControl}
        <TextFieldFormGroup
          help='Alphanumeric characters'
          value={driversLicense}
          controlId='driversLicense'
          controlLabel='Driver License/Government ID'
          validationState={state.driversLicenseValidationState}
          handleFieldChange={(e) => this.handleDriverLicenseChange(e)}
        />

        <TextFieldFormGroup
          help='Alphanumeric characters'
          value={passportNumber}
          controlId='passportNumber'
          controlLabel='Passport Number'
          validationState={state.passportNumberValidationState}
          handleFieldChange={(e) => this.handlePassportNumberChange(e)}
        />

        <FormGroup controlId='isAccreditedInvestor'>
          <FormCheck
            defaultChecked={isAccreditedInvestor}
            onClick={(e) => this.handleCheckboxClick(e, 'isAccreditedInvestor')}
            className='checkbox-inline'
            inline
            title='Hello'
          >
            <strong>Accredited Investor</strong>
          </FormCheck>
        </FormGroup>

        <FormGroup controlId='notes'>
          <FormLabel>Notes</FormLabel>
          <FormControl
            style={{ height: '180px' }}
            value={notes}
            as='textarea'
            onChange={(e) => this.handleFieldChangeNoValidation(e, 'notes')}
          />
        </FormGroup>
        {currentPhase === 'kyc' && (
          <Alert className='m-b-sm m-t-sm' variant='warning'>
            You are going to rerun AML
          </Alert>
        )}
        {isChangesSaved && (
          <Alert className='m-b-sm m-t-sm' variant='success'>
            Identity has been successfully updated
          </Alert>
        )}
        <div className='text-end'>
          {isChangesSaved ? (
            <Button className='m-r-sm' onClick={(e) => this.handleCloseModal(e)}>
              Close
            </Button>
          ) : (
            <Button className='m-r-sm' onClick={() => cancelIdentityInfoModalDialog()}>
              Cancel
            </Button>
          )}
          {!isChangesSaved && isValidated && (
            <Button variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Save changes
            </Button>
          )}
          {!isChangesSaved && !isValidated && (
            <Button disabled variant='primary' onClick={(e) => this.handleSaveChanges(e)}>
              Save changes
            </Button>
          )}
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  isChangesSaved: state.identityInfoModalDialog.isChangesSaved,
  isValidated: state.identityInfoModalDialog.isValidated,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      validateIdentityInfoModalDialog,
      closeIdentityInfoModalDialog,
      cancelIdentityInfoModalDialog,
      saveChangesIdentityInfoModalDialog,
      updateIdentity,
      fetchUserTxById,
      fetchAppContextForTx,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdentityInfoForm))
